import { render, staticRenderFns } from "./ModalChangeStageProtocol.vue?vue&type=template&id=287fc8a8&scoped=true"
import script from "./ModalChangeStageProtocol.vue?vue&type=script&lang=js"
export * from "./ModalChangeStageProtocol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287fc8a8",
  null
  
)

export default component.exports